import AsideLayout from '../../components/layouts/aside-layout';
import AsideNavLink from '../../components/aside-nav-link';
import LeadingLinks from '../../components/leading-links';
import MainLayout from '../../components/layouts/main-layout';
import TeamMemberList from '../../components/team-members/team-member-list';
import HeroBoardOfDirectors from '../../components/blocks/hero-board-of-directors';
import Head from 'next/head';

import Image1 from '../../public/img/team-members/stuart-robertson.jpg';
import Image2 from '../../public/img/team-members/scott-baldwin.jpg';
import Image6 from '../../public/img/team-members/craig-parker.jpg';
import Image7 from '../../public/img/team-members/kellie-cordner.jpg';

export default function BoardOfDirectors() {
    return (
        <MainLayout>
            <Head>
                <title>Board of Directors | Solvar</title>
                <meta name="description" content="Solvar board of directors."></meta>
            </Head>
            <HeroBoardOfDirectors />
            <AsideLayout
                heroImageSize="medium"
                prev={
                    <LeadingLinks href="/about-us/history" prev>History</LeadingLinks>
                }
                next={
                    <LeadingLinks href="/about-us/management-team" next>Management Team</LeadingLinks>
                }
                location={
                    <p className="capitalize text-bb">
                        <span className="font-bold">About Us</span> › Board of Directors
                    </p>
                }
                aside={
                    <>
                        <h6 className="text-h3 text-bb pb-20">About Us</h6>
                        <AsideNavLink href="/about-us/company-overview">Company Overview</AsideNavLink>
                        <AsideNavLink href="/about-us/history">History</AsideNavLink>
                        <AsideNavLink href="/about-us/board-of-directors" active={true}>Board of Directors</AsideNavLink>
                        <AsideNavLink href="/about-us/management-team">Management Team</AsideNavLink>
                        <AsideNavLink href="/about-us/corporate-governance">Corporate Governance</AsideNavLink>
                        <AsideNavLink href="/about-us/philanthropy">Philanthropy</AsideNavLink>
                        <AsideNavLink href="/about-us/sustainability">Sustainability</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Investors</h6>
                        <AsideNavLink href="/investors/shareholder-information">Shareholder Information</AsideNavLink>
                        <AsideNavLink href="/investors/company-announcements">Company Announcements</AsideNavLink>
                        <AsideNavLink href="/investors/annual-reports">Annual Reports</AsideNavLink>
                        <h6 className="text-h3 text-bb pb-20 pt-40">Contact</h6>
                        <AsideNavLink href="/contact/contact-us">Contact Us</AsideNavLink>
                    </>
                }
            >
                <h1 className="text-bb pb-40">Board of Directors</h1>
                <TeamMemberList
                    items={
                        [
                            {
                                firstName: "Stuart",
                                lastName: "Robertson",
                                title: "Non-Executive Chairman B.Com ACA FFINSIA GAICD MBA",
                                bio: (
                                    <p>Stuart is the head of Private Assets, SIV and Distribution at Ellerston Capital and has been with the firm since his return from London in 2012. Stuart has held executive roles at BT Funds Management, KBC Investments Limited and Zurich Financial Services both in Australia, London and New York. He is a qualified Chartered Accountant, a Fellow of Financial Services Institute of Australasia (FINSIA) and graduate of the Australian Institute of Company Directors. In addition, he holds a Masters in Business Administration from the Macquarie Graduate School of Management.</p>
                                ),
                                image: Image1,
                            },
                            {
                                firstName: "Scott",
                                lastName: "Baldwin",
                                title: "Managing Director and CEO BEng MBA GAICD",
                                bio: (
                                    <p>Joining Solvar in 2008 as the Chief Operating Officer, Scott brought a wealth of experience in sales, marketing and technology. Appointed to the board in 2009, Scott established and led the growth of the secured finance division at Solvar. Prior to joining Solvar, Scott spent over a decade in a variety of senior roles with General Electric Healthcare, from Sales & Service across Asia to leading infrastructure projects and working on the Asian Mergers and Acquisitions team.</p>
                                ),
                                image: Image2,
                            },
                            {
                                firstName: "Craig",
                                lastName: "Parker",
                                title: "Non-Executive Director BA (Econ) B.Ec (Acc & Fin) MBA CPA ",
                                bio: (
                                    <>
                                        <p>Craig retired from Westpac in 2023 after 41 years of service. Since 2005, Craig was responsible for Westpac's global structured finance and securitisation activities. Westpac dominates the Securitisation and Structured Finance market across Australia and New Zealand in all major asset classes including Residential Mortgages and Auto Loans.</p>
                                        <p>Craig previously led Client Relationship Management and Corporate Finance teams in Australia and Hong Kong. He holds a BA (Economics), B.Ec (Accounting & Finance) and an MBA from Macquarie University, Sydney. He is also a CPA. Craig was recognised as a Fellow of the Australian Securitisation Forum recognising his contribution to the Securitisation industry.</p>
                                        <p>Craig is also a Director of Firstmac Limited, a major non-Bank Residential Mortgage company and Chairs its Audit Committee. In addition, he is also a director of Forsight Australia, a Disability Accommodation and Services organisation and is Chair of its Finance, Audit and Risk Committee.</p>
                                    </>
                                ),
                                image: Image6,
                            },
                            {
                                firstName: "Kellie",
                                lastName: "Cordner",
                                title: "Non-Executive Director B.Bus (Mktg) GAICD ",
                                bio: (
                                    <>
                                        <p>Ms Cordner brings more than 20 years of executive leadership experience across marketing, customer experience and digital transformation. She has held Chief Marketing Officer roles at Carsales.com.au and Wesfarmers OneDigital, and more recently advised scale-ups on marketing strategy and transformation to support Series B funding and long-term growth.</p>

                                        <p>At Wesfarmers OneDigital, she led the launch and growth of the OnePass subscription program, securing partnerships with major retailers including Bunnings, Officeworks and Priceline. During her time at Carsales.com.au, she was instrumental in driving the company's growth through leadership of marketing, content and customer care.</p>

                                        <p>Ms Cordner holds a Bachelor of Business (Marketing) and has contributed to industry development as a member of the Marketing Industry Advisory Board at Monash University.</p>
                                    </>
                                ),
                                image: Image7,
                            }
                        ]
                    }
                />
            </AsideLayout>
        </MainLayout>
    );
}